/**
 * Possible outputoptions of the imageresizer
 */
export enum ImageResizerOutputypeEnum {
  JPG = "image/jpeg"
}
